module.exports = __webpack_public_path__ + "static/media/step-5.c4ec7416.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BuyForMe/icons/step-5.svg
 ** module id = 879
 ** module chunks = 0
 **/